import React from 'react'

const InstructionsContext = React.createContext("");

export const InstructionsProvider = InstructionsContext.Provider

export default InstructionsContext